import { app } from './app'
import { createConfig } from './config'
import { globalState } from './globalState'
import { initializeStore } from './store'
import { ICXF } from './types/cxf'
import { loadScript, log, logError } from './utils'

// eslint-disable-next-line @typescript-eslint/no-var-requires, unicorn/prefer-top-level-await
require('@goodgamestudios/cxf-ready').then((cxf: ICXF) => {
    // Initialize global state
    const config = createConfig(cxf.gameId)
    globalState.setConfig(config)
    globalState.setCxf(cxf)

    const store = initializeStore(cxf)
    globalState.setStore(store)

    // Canvas agent.js load
    loadScript(config.CANVAS_AGENT_URL as string)
        .then(() => {
            log(`Canvas agent loaded: ${config.CANVAS_AGENT_URL}`)
        })
        .catch((error: Error) => {
            logError('Canvas agent load error', error)
        })

    // Start the app
    app(cxf)
})
